import { useEffect, useState } from "react";
import AdminLayout from "../../layouts/AdminLayout";

import { getLeads, deleteLead } from "../../services/leadService";
import { FaPhoneAlt, FaWhatsapp, FaTrash } from "react-icons/fa";

import "./AdminLeads.css";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    loadLeads();
  }, []);

  const loadLeads = async () => {
    const data = await getLeads();

    setLeads(data);
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Delete this lead?");

    if (!confirmDelete) return;

    await deleteLead(id);

    loadLeads();
  };

  return (
    <AdminLayout>
      <div className="leads-page">
        <h1>Demo Requests</h1>

        <div className="leads-grid">
          {leads.length === 0 ? (
            <div className="no-leads">
              <h3>No Demo Requests Found</h3>
            </div>
          ) : (
            leads.map((lead) => {
              const whatsappMessage = `Hi ${lead.name},

Thank you for requesting a demo of NN AI Gym Management System.

We'd be happy to schedule a demo at your convenience.

Regards,
NN AI Solutions`;

              return (
                <div key={lead.id} className="lead-card">
                  <h3>{lead.gymName}</h3>

                  <p>
                    <strong>Owner:</strong>
                    {lead.name}
                  </p>

                  <p>
                    <strong>Phone:</strong>
                    {lead.phone}
                  </p>

                  <p>
                    <strong>Email:</strong>
                    {lead.email}
                  </p>

                  <p>
                    <strong>Message:</strong>
                    {lead.message}
                  </p>

                  <div className="lead-actions">
                    <a
                      href={`tel:${lead.phone}`}
                      className="call-btn"
                      title="Call"
                    >
                      <FaPhoneAlt />
                    </a>

                    <a
                      href={`https://wa.me/91${lead.phone}?text=${encodeURIComponent(
                        whatsappMessage,
                      )}`}
                      target="_blank"
                      rel="noreferrer"
                      className="whatsapp-btn"
                      title="WhatsApp"
                    >
                      <FaWhatsapp />
                    </a>

                    <button
                      onClick={() => handleDelete(lead.id)}
                      className="delete-btn"
                      title="Delete"
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
